/**
 * System ACL identification and metadata
 *
 * System ACLs are created by the edge agent (not user-configured).
 * They should be displayed as read-only with descriptive tooltips.
 */

export const SYSTEM_ACL_TAGS: Record<string, { description: string; purpose: string }> = {
  'tap300DefaultOutbound': {
    description: 'Management Outbound Filter',
    purpose: 'Allows DNS, HTTPS, IKEv2 NAT-T traffic on management interface (tap300)',
  },
  'suricata-ingress-acl': {
    description: 'Suricata Service Chain',
    purpose: 'Routes traffic to Suricata IDS/IPS while exempting ESP, WireGuard, and IKEv2 protocols',
  },
  'ikev2-nat-t-punt': {
    description: 'IKEv2 NAT-T Punt',
    purpose: 'Punts IKEv2 NAT Traversal (UDP 4500) traffic for StrongSwan processing',
  },
};

export function isSystemAcl(aclName: string): boolean {
  return aclName in SYSTEM_ACL_TAGS;
}

export function getAclDescription(aclName: string): string | null {
  return SYSTEM_ACL_TAGS[aclName]?.description ?? null;
}

export function getAclPurpose(aclName: string): string | null {
  return SYSTEM_ACL_TAGS[aclName]?.purpose ?? null;
}

/**
 * Map VPP protocol numbers/strings to display names
 */
export function getProtocolName(protocol: number | string): string {
  if (typeof protocol === 'string') {
    const lower = protocol.toLowerCase();
    const map: Record<string, string> = {
      tcp: 'TCP', udp: 'UDP', icmp: 'ICMP', esp: 'ESP', any: 'Any',
      icmpv6: 'ICMPv6', gre: 'GRE', sctp: 'SCTP',
    };
    return map[lower] || protocol.toUpperCase();
  }
  switch (protocol) {
    case 0: return 'Any';
    case 1: return 'ICMP';
    case 6: return 'TCP';
    case 17: return 'UDP';
    case 50: return 'ESP';
    case 47: return 'GRE';
    case 58: return 'ICMPv6';
    case 132: return 'SCTP';
    default: return `Proto ${protocol}`;
  }
}
